import { usePage } from "@inertiajs/vue2";

export function hasPermissionTo(permission) {
    const auth = usePage().props.auth;
    if (!auth) return false;
    if (!auth.permissions) return false;

    return auth.permissions.includes(permission);
}
